module.exports = __webpack_public_path__ + "fonts/c510d68f534ffe709998b7f93f0674a4.svg";